<template>
  <v-container fluid class="grow pb-0 fill-height">
    <v-row dense class="fill-height">
      <v-col cols="8">
        <v-card style="height: 100%;">
          <v-card-text style="height:100%; overflow: hidden;">
           
            <v-row class="ma-0 pa-0 info-container" :class="orderType != 'delivery' ? 'takeaway' : '' " dense>
              <v-col class="">
                <h3><T>Гость</T></h3>
                <v-divider class="mb-3"></v-divider>
                <ValidInfoField dense :label="$t('ФИО')" :rules="[rules.required, rules.nameRule(2)]" :value="guest ? guest.name : $t('Не задано')" />
                <ValidInfoField dense :label="$t('Номер телефона')" :rules="[rules.required, rules.phoneRule]" :value="phone ? phone.number : $t('Не задано')" >
                  <template v-if="phone && phone.number.length" #inner>
                    <PhoneFormatter v-model="phone.number">
                    </PhoneFormatter>
                  </template>
                </ValidInfoField>
                <ValidInfoField dense :label="$t('Email')" :rules="[rules.emailRule]" :value="guest ? guest.email : $t('Не задано')" />
              
              </v-col>
              <v-col class="">
                <h3><T>Корзина</T></h3>
                <v-divider class="mb-3"></v-divider>
                <ScrollerHanlder >
                  
                  <div :key="'empty_order'" v-if="!Object.keys(order).length"><T>Корзина пуста</T></div>
                  <OrderTable key="order"  v-else :order="order"/>
                  <!-- <table :key="'order'" v-else style="width: 100%">
                    <tr v-for="item in order.items" :key="item.line_guid">
                      <td style="font-size: 1.12em;">
                        {{ item.name }}
                        <div class="text-caption ml-3" v-for="modifier, n in item.modifiers" :key="n">
                          x{{modifier.quantity}} {{modifier.name}}
                        </div>
                      </td>
                      <td style="text-align: end; vertical-align: top">x{{ item.quantity }}</td>
                      <td style="text-align: end; vertical-align: top">={{ (item.sum).toFixed(2) }}</td>
                    </tr>
                    <tr style="font-size: 1.2em; font-weight: 500">
                      <td><T>Итого</T></td>
                      <td colspan="2">={{ order.order_total.toFixed(2) }}</td>
                    </tr>
                  </table> -->
                </ScrollerHanlder>
              
              </v-col>
            </v-row>
            <v-divider class="mb-3"></v-divider>
            <transition name="slideY">
              <v-row class="ma-0 pa-0" dense v-if="orderType == 'delivery'" :key="1">
                <v-col class="">
                  <InfoField :label="$t('Адрес доставки')">
                    {{ address ? address.value : $t("Не задано") }}
                  </InfoField>
                  <InfoField :label="$t('Зона доставки')" dense>
                    {{ delivery_zone ? delivery_zone.name : $t("Не задано")}}
                  </InfoField>
                  <!-- <InfoField :label="$t('Минимальная сумма заказа')" dense>
                    {{ "100р" }}
                  </InfoField>
                  <InfoField :label="$t('Стоимость доставки')" dense>
                    {{ "Бесплатно" }}
                  </InfoField> -->
                </v-col>
              </v-row>
            </transition>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="4">
        <v-card style="height: 100%; position: relative;">
          <v-card-text>
            <h3><T>Оформление</T></h3>
            <v-divider class="mb-3"></v-divider>
            
            <v-form>
              <v-row><v-col>
                <DatetimeOrder v-model="deliveryDate" :order_type="this.$store.getters.orderType"/>
              </v-col></v-row>

              <v-row><v-col>
                <TextField
                :label="$t('Комментарий к заказу')"
                hide-details
                multiline
                v-model="orderComment"
                >
                </TextField>
              </v-col></v-row>
              
              <v-row><v-col>
                <SelectField 
                hide-details
                :label="$t('Тип оплаты')"
                :items="payment_types"
                v-model="payment"
                />
              </v-col></v-row>

              <v-row v-if="payment === 'CASH'">
                <v-col>
                  <TextField :label="$t('Будет внесено наличными')" type="number" :min="0" v-model="guest_cash"/>
                  <TextField disabled :label="$t('Сдача клиенту')" type="number" :min="0" v-model="guest_change"/>
                </v-col>
              </v-row>
              
            </v-form>
            <div class="btn-container">
              <v-btn color="primary" class="mt-5" @click="saveOrder"><v-icon class="mr-1">mdi-bookmark-check-outline</v-icon><T>Принять заказ</T></v-btn>
              <v-dialog v-model="cancel" width="500">
                <template v-slot:activator="{on, attrs}">
                  <v-btn color="secondary darken-2" text class="mt-5" v-bind="attrs" v-on="on"><v-icon class="mr-1">mdi-trash-can-outline</v-icon><T>Отменить заказ</T></v-btn>
                </template>
                <v-card>
                  <v-card-title>
                    <T>Отмена заказа</T>
                  </v-card-title>
                  <v-card-text><T>Введенная информация по заказу будет очищена.</T><br><T>Изменения будут утрачены.</T><br><T>Отменить заказ?</T></v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="black" text @click="cancel = false">
                      <v-icon class="mr-1"> mdi-close<T>Отмена</T></v-icon>
                      <T>Отмена</T>
                    </v-btn>
                    <v-btn color="error" text @click="$emit('onCancel'); cancel=false">
                      <v-icon class="mr-1">mdi-trash-can-outline</v-icon>
                      <T>Отменить заказ</T>
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

    </v-row>
  </v-container>
</template>

<script>
import ScrollerHanlder from '@/components/scroller_handler';
import SelectField from '@/components/common/SelectField.vue';
import ValidInfoField from './ValidInfoField.vue';
import rules_mixin from '@/components/common/rules_mixin.js';
import TextField from '../../../common/TextField.vue';
import InfoField from '@/components/common/InfoField.vue';
// import DateOrderPicker from './DateOrderPicker';
import PhoneFormatter from '@/components/common/PhoneFormatter.vue';
import OrderTable from '../../../common/OrderTable.vue';
import DatetimeOrder from './DatetimeOrder'

import { mapActions } from 'vuex';
import { isValidPhoneNumber } from 'libphonenumber-js'
// import { DateTime } from 'luxon'

// import {OrderDateTime, Interval} from '../../../../helpers/order_datetime.js'

export default {
  mixins: [rules_mixin],
  props: {
    value: Object,
    guest: Object,
    phone: Object,
    address: Object,
    orderType: String,
    order: Object,
    date: [Date, Object],
    comment: String,
    payment_type: String,
    delivery_zone: Object
  },
  data: ()=>({
    date_modal: false,
    loading: false,
    cancel: false,
    guest_cash: 0
  }),
  computed:{
    addressCordinates(){
      return this.address ? this.address.coordinates : {lat: 55.7558, lng: 37.6173}
    },
    payment_types(){
      return [{text: this.$t("безналичный расчет"), value:"CARD"}, {text: this.$t("наличный расчет"), value: 'CASH'}] //, {text: this.$t("онлайн расчет"), value: 'CASH'}]
    },
    deliveryDate:{
      set(v){
        this.$emit('onDeliveryDate', v)
      },
      get(){
        return this.date
      }
    },
    payment: {
      get(){
        return this.payment_type
      },
      set(v){
        this.$emit('onPayment', v)
      }
    },
    orderComment:{
      set(v){
        this.$emit('onComment', v)
      },
      get(){
        return this.comment
      }
    },  
    schedule() {
      return this.$store.getters.local_refs.schedule || {}
    },
    date_and_time(){
      return new Date()
    },
    guest_change(){
      return (this.guest_cash - this.order.order_total).toFixed(2)
    }
  },
  methods: {
    ...mapActions(['throwTimeoutMessage']),  

    checkFields(){
      if(this.guest?.name == undefined || this.guest.name.length < 3){
        this.throwTimeoutMessage({
          message_data: this.$t('Имя клиента не задано'),
          message_class: 'error'
        })
        return false
      }

      if(this.phone.number == "" || !isValidPhoneNumber(this.phone.number)){
        this.throwTimeoutMessage({
          message_data: this.$t('Номер телефона клиента не задан'),
          message_class: 'error'
        })
        return false
      }
      
      if(!this.address && this.orderType === 'delivery'){
        this.throwTimeoutMessage({
          message_data: this.$t('Не задан адрес доставки'),
          message_class: 'error'
        })
        return false
      }

      if(this.payment_type === 'CASH' && (this.guest_change < 0)){
        this.throwTimeoutMessage({
          message_data: this.$t("Неверно рассчитана сдача клиенту. Измените значение в поле 'Будет внесено наличными'"),
          message_class: 'error'
        })
        return false
      }

      // if (this.delivery_date < DateTime.local()){
      //   this.$store.dispatch('throwTimeoutMessage', {
      //     text: this.$t('Неправильное время доставки'),
      //     message_class: 'error'
      //   })
      //   return false
      // }

      if(this.guest.email){
        if (typeof this.rules.emailRule(this.guest.email) == 'string'){
          this.throwTimeoutMessage({
            message_data: this.$t('Неправильный email'),
            message_class: 'error'
          })
          return false  
        }
      }

      return true
    },

    saveOrder(){
      if(this.checkFields()){
        if(this.payment_type === 'CASH' && this.guest_change !== 0)
          this.orderComment = `${this.comment ? this.comment : ''}\n ${this.$t(`Сдача:`)}${this.guest_change}\n`
        this.$emit('onSave')
      }
    },
  },
  mounted(){
    if(!this.payment){
      this.payment = this.payment_types[0].value
    }
    // if(!this.date){
      
    //   // let now = DateTime.local().plus({hours: 1})
    //   let now = new OrderDateTime(new Interval(this.$store.getters.local_refs.schedule))
    //   this.$emit('onDeliveryDate', now)
    // }
  },
  // watch:{
  //   payment(val){
  //     if(val == undefined){
  //       this.payment = this.payment_types[0].value
  //     }
  //   }
  // },
  components:{
    ValidInfoField,
    InfoField,
    ScrollerHanlder,
    SelectField,
    TextField,
    PhoneFormatter,
    // DateOrderPicker,
    OrderTable,
    DatetimeOrder
}
}
</script>

<style scoped>
  .btn-container{
    display: flex; 
    flex-direction: column; 
    justify-content: space-between; 
    position: absolute; 
    bottom: 5px; 
    left: 0; 
    width: 100%; 
    padding: 0 15px;
  }

  .scroller-container {
    height: calc(100% - 35px);
  }

  .info-container{
    height: calc(100% - 300px);
    transition: all 1s ease;
  }
  .info-container.takeaway{
    height: 100%;
  }

  .slideY-enter-active{
    transition: all 1s ease;
    transform: translateY(40%);
    opacity: 0;
  }

  .slideY-enter-to{
    transform: translateY(0);
    opacity: 1;
  }

  .slideY-leave-active{
    transition: all 1s ease;
    transform: translateY(0);
    opacity: 1;
  }

  .slideY-leave-to{
    transform: translateY(40%);
    opacity: 0
  }

</style>